import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, View } from "react-native"
import { Divider, List } from "react-native-paper"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"
import { activities } from "./DiagnosticConclusionLogic"
import styles from "./styles"
import { ModalCreateVideoPoint } from "./ModalCreateVideoPoint"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { useRecoilState } from "recoil"
import DiagnosticConclusionFooter from "./DiagnosticConclusionFooter"
import DiagnosticConclusionProgram from "./DiagnosticConclusionProgram"
import ConclusionItemDetails from "./ConclusionItemDetails/ConclusionItemDetails"
import ConclusionSkills from "./ConclusionSkills"
import ConsentementBeforeValidation from "./ConsentementBeforeValidation/ConsentementBeforeValidation"
import { Button } from "@Components/CustomButton/Button"
import { useConclusionHooks } from "../../../Hooks/useConclusionHooks"
import { UserProgramContext } from "@Providers/ProgramProvider"

const DiagnosticConclusion = ({ navigation }) => {
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const [canValidate, setCanValidate] = useState(false)
    const [openVideoPointModal, setOpenVideoPointModal] = useState(false)
    const goBack = () => navigation.goBack()
    const { handleFetchConclusion, conclusion, fetchingConclusions } = useConclusionHooks()

    useEffect(() => {
        handleFetchConclusion()
    }, [])

    const [isModalVisible, setIiModalVisible] = useState(false)
    const [isConsentModalVisible, setConsentModalVisible] = useState(true)
    const [selectedConclusion, setselectedConclusion] = useState({
        label: "",
        details: "",
        subtitle: ""
    })
    const toggleModal = () => setIiModalVisible(!isModalVisible)
    const toggleModalConsentModal = () => setConsentModalVisible(!isConsentModalVisible)
    const { preselectedPatientProgram } = useContext(UserProgramContext)

    const handlePressConclusion = (element) => {
        setselectedConclusion({
            label: element?.title,
            details: element?.description,
            subtitle: element?.subtitle ?? ""
        })
        toggleModal()
    }

    const programName = preselectedPatientProgram?.[0]?.programTitle ?? ""

    // if (currentEducationalDiagnosis === null) {
    //     navigation.navigate("Diagnostic")
    // }

    return (
        <View style={styles.container}>
            <CustomScrollview contentContainerStyle={{ paddingHorizontal: 15 }}>
                <View>
                    <BreeSerifText color={baseColors.green.primary} fontSize={22} style={{ marginBottom: 20 }}>
                        Conclusion du Diagnostic
                    </BreeSerifText>

                    <OpenSansText fontSize={14}>
                        Voici les résultats de votre Diagnostic Éducatif. Vous pouvez le valider ou bien le refuser et
                        reprogrammer une autre consultation en cas de désaccord.
                    </OpenSansText>

                    <Spacer />

                    <View style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
                        <OpenSansText
                            color={baseColors.orange.primary}
                            fontFamily={baseFontFamily.OpenSansBold}
                            fontSize={14}
                        >
                            PROGRAMME :{" "}
                        </OpenSansText>

                        <OpenSansText fontFamily={baseFontFamily.OpenSansBold} fontSize={14}>
                            {programName}
                        </OpenSansText>
                    </View>
                </View>

                {fetchingConclusions ? (
                    <ActivityIndicator style={{ marginTop: 50 }} color={baseColors.orange.primary} size={50} />
                ) : (
                    <>
                        <View style={styles.content}>
                            {activities(conclusion).map((item, index) => {
                                if (item?.isSkills || item.isGoals) {
                                    return (
                                        <View key={index}>
                                            <ConclusionSkills
                                                isGoals={item.isGoals}
                                                title={item?.title}
                                                skills={item?.skills}
                                                goals={item?.goals}
                                            />
                                            <Divider style={styles.divider} />
                                        </View>
                                    )
                                }

                                return (
                                    <List.Section key={index}>
                                        <List.Item
                                            descriptionNumberOfLines={3}
                                            style={styles.item}
                                            title={item.title}
                                            titleStyle={styles.titleStyle}
                                            description={item.description === "" ? "(non renseigné)" : item.description}
                                            descriptionStyle={styles.descriptionStyle}
                                            onPress={() =>
                                                item?.isPressable ? handlePressConclusion(item) : undefined
                                            }
                                        />
                                        <Divider style={styles.divider} />
                                    </List.Section>
                                )
                            })}
                        </View>

                        <Spacer height={40} />

                        <DiagnosticConclusionProgram conclusion={conclusion} />

                        <Spacer />

                        <Button
                            onPress={toggleModalConsentModal}
                            text={"Donner mon consentement"}
                            width="90%"
                            height={40}
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                        />

                        <Spacer />
                    </>
                )}
            </CustomScrollview>

            <DiagnosticConclusionFooter
                canValidate={canValidate}
                fetching={fetchingConclusions}
                conclusion={conclusion}
            />

            <ConclusionItemDetails
                isModalVisible={isModalVisible}
                toggleModal={toggleModal}
                selectedConclusion={selectedConclusion}
            />

            <ConsentementBeforeValidation
                canValidate={canValidate}
                setCanValidate={setCanValidate}
                isModalVisible={isConsentModalVisible}
                toggleModal={toggleModalConsentModal}
                selectedConclusion={selectedConclusion}
            />

            <ModalCreateVideoPoint
                toggleModal={() => setOpenVideoPointModal(false)}
                openModal={openVideoPointModal}
                redirectToHome={() => goBack()}
            />
        </View>
    )
}

export default DiagnosticConclusion
